<!--
 * $Description: 
 * $Author: Betway
 * @LastEditors: lwq
 * $Date: 2020年05月28日 14:15:56 +0800
 * @LastEditTime: 2020-07-20 11:37:46
 * @FilePath: \mrc-base-server-view\src\components\mrc_ess_tabs.vue
--> 
<template>
  <v-tabs v-model="tab"
          :background-color="backgroundColor"
          centered
          grow>
    <template v-for="(item,n) in items">
      <v-tab :key="n+1"
             :href="`#tab-${n+1}`"
             class="text-capitalize">{{item}}</v-tab>
    </template>
    <v-tabs-items class="mt-4"
                  v-model="tab">
      <v-tab-item v-for="(item,n) in items"
                  :key="`${n+1}-content`"
                  :value="`tab-${n+1}`">
        <slot :name="`content-${n+1}`"></slot>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>
<script>
export default {
  name: "MrcTaber",
  computed: {},
  watch: {
    tab (val) {
      this.$emit("change", val);
      this.$store.commit("setTab", val)
    }
  },
  props: {
    // , required: true
    curTab: { default: "tab-1", type: String },
    items: { default: [], type: [Array, String], required: true },
    backgroundColor: { default: "transparent", type: String },
    contentBackground: { default: " pa-3", type: String }
  },
  mounted () {
    this.tab = this.$store.state.tab || this.curTab;
  },
  data () {
    return {
      tab: "tab-1"
    };
  },
  beforeDestroy () {
    this.$store.commit('setTab', '')
  }
};
</script>